// src/features/notifications/showOrderNotification.js
import toast from "react-hot-toast";
import "./orderToast.css";

// Helper to get details for each type
const getNotificationDetails = (data) => {
  const base = {
    orderType: data.order_type,
    symbol: data.symbol || "BTCUSD",
    quantity: data.quantity || 0,
    side: data.side || "BUY",
    price:
      data.type === "position_closed"
        ? data.close_price || data.entry_price || null
        : data.price || data.entry_price || null,
    take_profit: data.take_profit || null,
    stop_loss: data.stop_loss || null,
  };

  switch (data.type) {
    case "order_placed":
      return {
        ...base,
        title:
          data.order_type === "limit"
            ? "Limit order placed on"
            : data.order_type === "stop-loss"
            ? "Stop-loss order placed on"
            : "Market order placed on",
        icon:
          data.side === "BUY" ? (
            <i class="bi bi-arrow-up"></i>
          ) : (
            <i class="bi bi-arrow-down"></i>
          ),
        typeClass: "placed",
      };

    case "order_filled":
      return {
        ...base,
        title:
          data.order_type === "limit"
            ? "Limit order executed on"
            : data.order_type === "stop-loss"
            ? "Stop-loss order executed on"
            : "Market order executed on",
        icon: <i class="bi bi-check-circle-fill"></i>,
        typeClass: "executed",
      };
    case "positions_updated":
      return {
        ...base,
        title: "Positions updated ",
        icon: <i class="bi bi-check-circle-fill"></i>,
        typeClass: "executed",
      };

    case "position_closed":
      return {
        ...base,
        title: "Position closed on",
        icon: <i class="bi bi-check-circle-fill"></i>,
        typeClass: "closed",
        pnl: data.pnl,
      };

    case "order_cancelled":
      return {
        ...base,
        title: "Order cancelled on",
        icon: <i class="bi bi-x-circle-fill"></i>,
        typeClass: "cancelled",
      };

    default:
      return {
        ...base,
        title: "Notification",
        icon: <i class="bi bi-info-circle"></i>,
        typeClass: "info",
      };
  }
};

export const showOrderNotification = (data) => {
  const details = getNotificationDetails(data);

  const toastId = `order-toast-${data.id || data.symbol}-${data.type}`;

  toast.custom(
    (t) => {
      return (
        <div className={`order-toast ${t.visible ? "show" : "hide"}`}>
          <div className={`order-toast-icon`}>{details.icon}</div>
          <div className="order-toast-content">
            <div className="order-toast-title">
              {details.title}
              {data.type !== "positions_updated" && (
                <span className="symbol-tag">{details.symbol}</span>
              )}
            </div>
            <div className="order-toast-details">
              {data.type === "positions_updated" ? (
                <>
                  {details.take_profit && (
                    <span className={`side symbol-tag BUY`}>
                      Take Profit at {details.take_profit}
                    </span>
                  )}
                  {details.stop_loss && (
                    <span className={`side symbol-tag SELL`}>
                      Stop Loss at {details.stop_loss}
                    </span>
                  )}
                </>
              ) : (
                <span className={`side symbol-tag ${details.side}`}>
                  {details.side === "BUY" ? "Buy" : "Sell"} {details.quantity}
                </span>
              )}
              {details.price &&
                !(
                  data.type === "order_placed" && data.order_type === "market"
                ) && <span> at {details.price}</span>}
              {data.type === "position_closed" &&
                typeof details.pnl !== "undefined" && (
                  <span
                    style={{
                      marginLeft: "8px",
                      color: details.pnl >= 0 ? "#4caf50" : "#f44336",
                    }}
                  >
                    PnL: {parseFloat(details.pnl).toFixed(2)}
                  </span>
                )}
            </div>
          </div>
          <button
            className="order-toast-close"
            onClick={() => toast.dismiss(toastId)}
          >
            ✕
          </button>
        </div>
      );
    },
    { id: toastId, duration: 3000 }
  ); // Add id for consistency
};
